import PropTypes from 'prop-types';
// @mui
import { alpha } from '@mui/material/styles';
import {
  List,
  IconButton,
  ListItemText,
  ListItem,
  Box,
  Dialog,
  DialogContent
} from '@mui/material';
// utils
import ReactPlayer from 'react-player';
import { useState } from 'react';
import { fData } from '../../utils/formatNumber';
import getFileData from '../../utils/getFileData';
//
import Image from '../Image';
import Iconify from '../Iconify';

// ----------------------------------------------------------------------

MultiFilePreview.propTypes = {
  files: PropTypes.array.isRequired,
  onRemove: PropTypes.func,
  showPreview: PropTypes.bool
};

export default function MultiFilePreview({ showPreview = false, files, onRemove }) {
  const hasFile = files.length > 0;

  // Video modal state
  const [videoModal, setVideoModal] = useState({
    isOpen: false,
    videoSrc: null
  });

  return (
    <List disablePadding sx={{ ...(hasFile && { my: 3 }) }}>
      {/* <AnimatePresence> */}
      {files.map((file, index) => {
        const { key, name, size, preview, type } = getFileData(file, index);

        if (showPreview) {
          return (
            <ListItem
              key={key}
              // component={m.div}
              // {...varFade().inRight}
              sx={{
                p: 0,
                m: 0.5,
                width: 80,
                height: 80,
                borderRadius: 1.25,
                overflow: 'hidden',
                position: 'relative',
                display: 'inline-flex',
                border: (theme) => `solid 1px ${theme.palette.divider}`
              }}
            >
              {type.includes('video') ? (
                <Box
                  sx={{
                    height: '100%',
                    width: '100%',
                    position: 'relative',
                    background: '#0006'
                  }}
                >
                  {/* eslint-disable */}
                    <video muted style={{ height: '100%', width: '100%', opacity: 0.4 }}>
                      <source src={preview} type={type} />
                    </video>
                  </Box>
                ) : (

                  <Image alt="preview" src={preview} ratio="1/1" />
                )}

                {onRemove && (
                  <IconButton
                    size="small"
                    onClick={() => onRemove(file)}
                    sx={{
                      top: 6,
                      p: '2px',
                      right: 6,
                      position: 'absolute',
                      color: 'common.white',
                      bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72),
                      '&:hover': {
                        bgcolor: (theme) => alpha(theme.palette.grey[900], 0.48)
                      }
                    }}
                  >
                    <Iconify icon="eva:close-fill" />
                  </IconButton>
                )}
                {type.includes('video') && <Iconify icon="bi:play-fill" sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  color: 'white',
                  cursor: 'pointer'
                }} height={28} width={28} onClick={() => setVideoModal({ isOpen: true, videoSrc: preview })}/>}
              </ListItem>
            );
          }

          return (
            <ListItem
              key={key}
              // component={m.div}
              // {...varFade().inRight}
              sx={{
                my: 1,
                px: 2,
                py: 0.75,
                borderRadius: 0.75,
                border: (theme) => `solid 1px ${theme.palette.divider}`
              }}
            >
              <Iconify
                icon="eva:file-fill"
                sx={{ width: 28, height: 28, color: 'text.secondary', mr: 2 }}
              />

              <ListItemText
                primary={typeof file === 'string' ? file : name}
                secondary={typeof file === 'string' ? '' : fData(size || 0)}
                primaryTypographyProps={{ variant: 'subtitle2' }}
                secondaryTypographyProps={{ variant: 'caption' }}
              />

              {onRemove && (
                <IconButton edge="end" size="small" onClick={() => onRemove(file)}>
                  <Iconify icon="eva:close-fill" />
                </IconButton>
              )}
            </ListItem>
          );
        })}
      {/* </AnimatePresence> */}

      <Dialog open={videoModal.isOpen} fullWidth onClose={() => setVideoModal({ isOpen: false, videoSrc: null })}>
        <DialogContent>
          <ReactPlayer
            url={videoModal.videoSrc}
            controls
            width="100%"
            height="100%"
            style={{
              borderRadius: '10px'
            }}
          />
        </DialogContent>
      </Dialog>
    </List>
  );
}
